import { Location, NgIf, AsyncPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ICurrency } from '@models/currency.model';
import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { IFundraiser } from '@models/fundraiser.model';
import {
  DonationConfirmationComponent
} from '@common-components/donation-confirmation/donation-confirmation.component';
import { CustomTranslatePipe } from '@pipes/translate/translate.pipe';
import { KettoAssuredComponent } from '../../../ketto-assured/ketto-assured.component';
import { CurrencyDropdownComponent } from '../../../currency-dropdown/currency-dropdown.component';

@Component({
  selector: 'app-payment-header-stories',
  templateUrl: './payment-header-stories.component.html',
  styleUrls: ['./payment-header-stories.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    RouterModule,
    CustomTranslatePipe,
    KettoAssuredComponent,
    CurrencyDropdownComponent
  ]
})
export class PaymentHeaderStoriesComponent {

  readonly vars = inject(VariablesService);

  private paymentUtil = inject(PaymentUtilService);
  public util = inject(UtilService);
  public location = inject(Location);
  private actRoute = inject(ActivatedRoute);
  public dialog = inject(MatDialog);
  public router = inject(Router);

  @Input() public fundraiser: IFundraiser;
  @Input() isReward;
  @Input() selectedCurrency;
  @Input() screenName;
  @Input() showBeneficiary;
  @Input() contributeDetails;
  @Input() isStandAlone;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  supportedCurrencies: ICurrency[];
  currency;
  params;
  currentUrl;
  domainUrl;
  isMobile = this.vars.isMobile;

  ngOnInit() {
    this.getCurrencyDetails();
    this.actRoute.queryParams.subscribe((params) => {
      this.params = params;
    });

    this.domainUrl = this.vars.domainData.url;
  }
  /**Get the details of the currency */
  getCurrencyDetails() {
    this.paymentUtil.supportedCurrencies.subscribe({
      next: (res) => {
        if (res) {
          setTimeout(() => {
            this.supportedCurrencies = res;
          }, 0);
        }
      }
    });
    this.paymentUtil.paymentCurrency.subscribe({ next: (res) => this.currency = res });
  }
  /**Get the title */
  getTitle(param, op) {
    if (op) {
      switch (op) {
        case 'c':
          return this.vars.isMobile ? '' : 'Enter your card details';
        case 'p':
          return 'Payment using PayTM';
      }
    } else {
      switch (param) {
        case 'rd':
          return 'Choose Reward amount';
        case 'form':
          return 'Choose a contribution amount';
        case 'options':
          return 'Choose payment option';
      }
    }
  }
  /**Get emited currency fromheader and set it */
  setCurrency(currency: ICurrency) {
    this.paymentUtil.paymentCurrency.next(currency.currency);
    this.userSelectionCurrency.emit(currency);
  }
  /**Back action of payment header */
  back() {
    if (this.screenName === this.params.payment) {
      if (!this.vars.isMobile) {
        const dialogRef = this.dialog.open(DonationConfirmationComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          width: '428px',
          panelClass: 'confirmation-modal'
        });
        dialogRef.componentInstance.cancelPayment.subscribe(() => {
          if (this.isStandAlone) {
            this.location.back();
          }
        });
      } else {
        this.dialog.closeAll();
        if (this.isStandAlone) {
          this.location.back();
        }
      }
    } else {
      this.location.back();
      this.paymentUtil.backButton.next(this.params);
      this.paymentUtil.cartSubs.forEach(s => s.unsubscribe());
    }
  }

}
